/* eslint-disable no-unused-expressions */
import { useTranslation } from "react-i18next";
import React, {useCallback, useEffect, useState, useRef} from 'react';
import './Login.scss';
import {Waiter} from '../WaitingSign/Waiting';
import PopUp from '../PopUp/PopUp';
import Cookie from 'js-cookie';
import {clientId, clientSecret, CST_ADMINISTRATIONSERVICE_API_URL, CST_SSOSERVICE_UI_URL} from '../../ssoSettings';
import {useQuery} from '../../hooks/useQuery';
import {useAppDispatch, useAppSelector} from '../../hooks/hooks';
import {Redirect, useHistory} from 'react-router-dom';
import axios from 'axios';
import {isUserLoggedIn, removeSSOCookies, setTokenExpireTime} from '../../Helpers/utils';
import {getUsersData} from '../../Redux/Actions/Users';
import {getUserData as getUserDataLogin} from '../../Redux/Actions/userData';
import jwtDecode from "jwt-decode";

type JwtPayload = {
  user_lang?: string;
  [key: string]: any;
};


export const Login: React.FC = () => {
	const { i18n } = useTranslation();

	const [showPopup, setShowPopup] = useState(false);
	const redirectingRef = useRef(false);
	const query = useQuery();
	const history = useHistory();
	const userData = useAppSelector((state) => state.userData);
	const dispatch = useAppDispatch();

	useEffect(() => {
		document.title = "e-Kontrole | Logowanie";
	});

	useEffect(() => {
		if (history.location.pathname === '/Callback') {
			handleLogin();
		}
	}, []);

	useEffect(() => {
		if (userData.error) {
			setShowPopup(true)
		}
	}, [userData.error]);



	const handleLogin = useCallback(() => {
		localStorage.removeItem("lang");
		removeSSOCookies();
		const code = query.get('code');
		const clientKey = btoa(`${clientId}:${clientSecret}`)
		axios.post(CST_ADMINISTRATIONSERVICE_API_URL + `/Token/AccessToken/${clientKey}`).then(
			s => {
				const headers = {
					Authorization: `Bearer ${s.data.token}`,
				};
				axios.post(CST_ADMINISTRATIONSERVICE_API_URL + `/Token/UserAuthentication/${code}`, '', { headers })
					.then((response) => {
						const token: string = response.data.token;
						const refreshToken = response.data.refreshToken;
						localStorage.setItem('token', token);
						localStorage.setItem('refreshToken', refreshToken);
						localStorage.setItem('is_logged', 'true');
						setTokenExpireTime(token);

                        dispatch(getUserDataLogin)
						dispatch(getUsersData())
						
						const decoded = jwtDecode<JwtPayload>(token);
						if (decoded?.user_lang) {
							localStorage.setItem("lang", decoded.user_lang);
							i18n.changeLanguage(decoded.user_lang);
						}


					}).then(() => {
						const redirectPath = localStorage.getItem('redirectPath');
						localStorage.removeItem('redirectPath');
						history.push(redirectPath || '/');
					})
			})
	}, []);

	if (userData.isLogged || isUserLoggedIn()) {

		if (history.location.pathname === '/Callback'){
        	return <Redirect to='/' />
		}
		return <Redirect to={history.location} />

	}
	else if (!redirectingRef.current && history.location.pathname !== '/' && !isUserLoggedIn() && history.location.pathname !== '/Callback'){
		redirectingRef.current = true;
		localStorage.setItem('redirectPath', history.location.pathname + history.location.search);
		window.location.href = `${CST_SSOSERVICE_UI_URL}?clientId=${clientId}`;
		return null;
	}

	return (
		<>
			{showPopup &&
				<PopUp type={'error'}
					title="Błąd"
					notification={userData.error}
					closePopUp={() => setShowPopup(false)}
				/>
			}
			<div id='login_container' className='login-container'>
				<h2 className='login-container__header'>Logowanie</h2>
				<div className='login-container__form'>
					<a id='sso-login-button' href={`${CST_SSOSERVICE_UI_URL}?clientId=${clientId}`}>Zaloguj za
						pomocą sso</a>
				</div>
			</div>

			<div id='waiter'><Waiter loading={userData.isLoading}/></div>
		</>
	)
};

export default Login;
